<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">
          <div class="header">
            <h1>Комплексная модернизация</h1>
            <div>
              <v-btn
                  v-if="$user.role === 'ROLE_VNII' || $user.role === 'ROLE_MINTRUD' || $user.role === 'ROLE_ADMIN'"
                  @click="$router.push('/standard/requests')"
                  outlined
              >
                просмотр всех заявок
              </v-btn>
            </div>
          </div>

          <template v-if="$user.role !== 'ROLE_CZN_TERRITORIAL'">
            <div class="standard-filters">
              <div>
                <h4>Уровень мониторинга:</h4>
                <v-radio-group v-model="monitoringLevel" row hide-details class="standard-filters__level" @change="loadData()">
                  <v-radio label="Заявки на участие в КМ" value="region"></v-radio>
                  <v-radio label="Акты комиссионного обследования" value="czn"></v-radio>
                </v-radio-group>
              </div>
              <div class="standard-filters__selector">
                <department-info v-if="monitoringLevel === 'czn'" @depObj="department = $event; loadData()"></department-info>
                <template v-else-if="monitoringLevel === 'region'">
                  <span v-if="$user.role === 'ROLE_REGIONAL_AGENCY' || $user.role === 'ROLE_REGIONAL_ADMINISTRATOR' || $user.role === 'ROLE_CZN_MANAGER'">
                    {{ userRegion.nameWithNetType }}
                  </span>

                  <v-autocomplete v-else-if="$user.role === 'ROLE_VNII' || $user.role === 'ROLE_MINTRUD' || $user.role === 'ROLE_ADMIN'"
                                  style="width: 500px;"
                                  label="Регион"
                                  :items="$cznDepartmentsByRegionList"
                                  item-text="nameWithNetType"
                                  return-object
                                  hide-details
                                  v-model="userRegion"
                                  @input="loadData()"
                  ></v-autocomplete>
                </template>
              </div>
              <div class="standard-filters__wave">
                <ModernizationWave :count="userRegion?.modernizationWave" />
              </div>
            </div>
          </template>
          <template v-else>
            <span>{{ $user.department.name }}</span>
          </template>

          <!-- Заявки на участие в комплексной модернизации -->
          <template v-if="monitoringLevel === 'region' && !loading">
            <template v-if="checkRoles(requestRoles) && !requests.length" class="mt-5">
              <p>Регион не участвует в комплексной модернизации</p>
              <p>Для участия в комплексной модернизации заполните заявку.</p>
              <v-btn
                  @click="createRequest"
                  outlined
                  :loading="processing"
                  :disabled="processing"
              >
                Заполнить заявку
              </v-btn>
            </template>

            <template v-if="checkRoles(requestRoles) && requests.length">
              <div class="standard-block__title">Заявки на участие в КМ</div>
              <div class="list">
                <table class="standard-table">
                  <colgroup>
                    <col class="standard-table__col-name">
                    <col class="standard-table__col-meta">
                    <col class="standard-table__col-meta">
                    <col class="standard-table__col-status">
                  </colgroup>
                  <thead>
                  <tr>
                    <th>Наименование</th>
                    <th>Дата создания</th>
                    <th>Дата отправки</th>
                    <th>Статус</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="request in requests" :key="'request_' + request.id">
                    <td>
                      <router-link :to="'/standard/request/' + request.id">
                        Заявка на участие в комплексной модернизации
                      </router-link>
                    </td>
                    <td>{{ request.createdDateTime | dateFormat }}</td>
                    <td>{{ request.sendDateTime | dateFormat }}</td>
                    <td>{{ requestStatuses[request.status] }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </template>

          <!-- Акты комиссионного обследования -->
          <template v-if="monitoringLevel === 'czn' && !loading">
            <div class="standard-block__title">Акты комиссионного обследования</div>
            <v-btn
                v-if="acts.length === 0"
                class="mt-3"
                @click="createAct"
                :loading="processing"
                :disabled="processing"
                outlined
            >
              Создать акт
            </v-btn>
            <div v-else class="list">
              <table class="standard-table">
                <colgroup>
                  <col class="standard-table__col-name">
                  <col class="standard-table__col-meta">
                  <col class="standard-table__col-meta">
                  <col class="standard-table__col-status">
                </colgroup>
                <thead>
                <tr>
                  <th>Наименование</th>
                  <th>Дата создания</th>
                  <th>Дата изменения</th>
                  <th>Статус</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="act in acts" :key="'act_' + act.id">
                  <td>
                    <router-link :to="'/standard/act/' + act.id">
                      Акт комиссионного обследования
                    </router-link>
                  </td>
                  <td>{{ act.createdDateTime | dateFormat }}</td>
                  <td>{{ act.updatedDateTime | dateFormat }}</td>
                  <td>{{ actStatuses[act.status] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
        <div v-if="errorText != null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <loader-dialog :show="loading" msg="Загрузка"></loader-dialog>
  </div>
</template>

<script>
import departmentInfo from "@/components/elements/DepartmentInfo";
import {
  getFormsByDomainAndCznId,
  getFormsByDomainAndRegionCode,
  saveForm
} from "@/modules/api.forms";
import {requestStatuses, actStatuses} from "@/modules/ApplicationRepository";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import ModernizationWave from "@/components/elements/ModernizationWave";
export default {
  name: 'StandardComponent',
  components: {
    LoaderDialog,
    departmentInfo,
    ModernizationWave
  },
  data: () => ({
    domainRequest: 'standard_request',
    domainAct: 'standard_act',
    requests: [],
    acts: [],
    loading: false,
    processing: false,
    requestRoles: ['ROLE_ADMIN', 'ROLE_VNII', 'ROLE_MINTRUD', 'ROLE_REGIONAL_AGENCY'],
    monitoringLevel: "region",
    department: {
      name: null,
    },
    userRegion: {},
    requestStatuses: requestStatuses,
    actStatuses: actStatuses,
    apiLoaded: false,
    errorText: null,
  }),
  methods: {
    async loadData() {
      if (this.$user.role === 'ROLE_REGIONAL_ADMINISTRATOR') return;

      this.loading = true
      if (this.monitoringLevel === 'region') {
        this.department = {
          name: null,
        }
      }

      await this.loadRequests()
      await this.loadActs()
      this.loading = false
    },
    async loadRequests() {
      this.requests = (await getFormsByDomainAndRegionCode(this.domainRequest, this.userRegion.code)).payload
    },
    async loadActs() {
      this.acts = (await getFormsByDomainAndCznId(this.domainAct, this.department.id)).payload
    },
    async withProcessing(action) {
      this.processing = true;
      try {
        await action();
      } catch (error) {
        alert("Ошибка при выполнении операции");
        console.error('Ошибка при выполнении операции:', error);
      } finally {
        this.processing = false;
      }
    },
    async createRequest() {
      await this.withProcessing(async () => {
        const requestForm = {
          domain: {
            code: this.domainRequest,
          },
          regionCode: this.userRegion.code,
          status: "DRAFT",
        }
        const request = await saveForm(requestForm)
        if (request) {
          await this.$router.push(`/standard/request/${request.payload.id}`)
        }
      });
    },
    async createAct() {
      await this.withProcessing(async () => {
        const actForm = {
          domain: {
            code: this.domainAct,
          },
          regionCode: this.department.region.code,
          cznId: this.department.id,
          status: "DRAFT",
        }
        const act = await saveForm(actForm)
        if (act) {
          await this.$router.push(`/standard/act/${act.payload.id}`)
        }
      });
    },
    checkRoles(userRoles) {
      for (let role of userRoles) {
        if (this.$user.subroles.includes(role)) {
          return true;
        }
      }
      return false;
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null || date === '') {
        return '—'
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
  async beforeMount() {
    this.apiLoaded = true;
    if (this.$user.role === 'ROLE_CZN_MANAGER' ||
        this.$user.role === 'ROLE_CZN_TERRITORIAL' ||
        this.$user.role === 'ROLE_REGIONAL_AGENCY' ||
        this.$user.role === 'ROLE_REGIONAL_ADMINISTRATOR'
    ) {
      this.userRegion = this.$cznDepartmentsByRegionList.find(region => region.code === this.$user.region.code);
    } else {
      this.userRegion = this.$cznDepartmentsByRegionList[0];
    }
    if (this.$user.role === 'ROLE_CZN_TERRITORIAL') {
      this.department = this.$user.department;
      this.monitoringLevel = 'czn';
    }
    await this.loadData();
  }
}
</script>

<style lang="scss">
@import "../../styles/main.scss";
</style>

<style lang="scss" scoped>
.standard-filters {
  margin-bottom: 16px;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    color: #1C1C1F;
    margin: 0 0 12px;
  }

  &__level {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
  }

  &__selector {
    margin-top: 20px;

    ::v-deep .v-input {
      margin-bottom: 0;
    }

    ::v-deep .v-input__slot {
      margin-bottom: 0;
    }

    ::v-deep .v-text-field__details {
      display: none !important;
      min-height: 0 !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden;
    }

    ::v-deep .two-columns {
      margin-bottom: 0;
      align-items: flex-end;

      > p {
        display: none;
      }
    }
  }

  &__wave {
    margin-top: 8px;
    margin-bottom: 20px;

    ::v-deep p {
      margin: 0;
    }
  }

  ::v-deep .v-text-field__details {
    display: none;
  }
}

.standard-block__title {
  font-weight: 600;
  font-size: 18px;
  color: #1C1C1F;
  margin-bottom: 12px;
  padding: 10px 14px;
  background: #F5F8FC;
  border-radius: 4px;
}

.list {
  table {
    border-collapse: collapse;
    width: 100%;

    th {
      border-bottom: 1px solid #E8E8E9;
    }

    td {
      padding: 10px 8px;
      vertical-align: middle;
    }
  }
}

.standard-table {
  table-layout: fixed;

  &__col-name {
    width: auto;
  }

  &__col-meta {
    width: 140px;
  }

  &__col-status {
    width: 220px;
  }

  th,
  td {
    padding: 10px 8px;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  th:not(:first-child),
  td:not(:first-child) {
    white-space: nowrap;
  }
}
</style>
